import DayCheckboxCard from './DayCheckboxCard';

export default DayCheckboxCard;
